<template>
  <div>
    <BoxWithTitle
      v-if="hasPermission('sites.view')"
    >
      <template #header>
        <v-toolbar-title>
          {{ $t('sites.document.info') }}
        </v-toolbar-title>
      </template>
      <template #icons>
        <v-btn
          v-if="hasPermission('sites.edit')"
          icon
          @click="onClickToggle"
        >
          <v-icon>
            {{ formEditable ? 'mdi-close' : 'mdi-pencil-outline' }}
          </v-icon>
        </v-btn>
      </template>
      <template #content>
        <form>
          <SiteDocumentForm
            ref="mainForm"
            :populateWith="updatedData"
            :isEditable="formEditable"
            :editForm="true"
            @dirtyChanged="isFormDirty = $event"
            @validChanged="isFormValid = $event"
            @sendData="updateData"
          />
          <v-row
            v-if="formEditable"
            align="center"
            justify="end"
            class="mr-1"
          >
            <v-btn
              text
              @click="onClickConfirmRemove"
            >
              <span class="text-danger">
                {{ $t('forms.btn.delete') }}
              </span>
            </v-btn>
            <v-btn
              :disabled="!isFormValid || !isFormDirty"
              type="submit"
              color="secondary"
              @click.prevent="onClickUpdate"
            >
              {{ $t('forms.btn.save') }}
            </v-btn>
          </v-row>
        </form>
      </template>
    </BoxWithTitle>
    <NoPermissionAlert
      v-else
      :message="$t('permissions.error')"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

import FormPageMixin from '@/mixins/FormPageMixin';
import BoxWithTitle from '@/components/shared/containers/VBoxWithTitle.vue';
import ConfirmForm from '@/components/shared/widgets/ConfirmForm.vue';
import SiteDocumentForm from '@/views/sites/document/SiteDocumentForm.vue';
import NoPermissionAlert from '@/components/shared/NoPermissionAlert';


export default {
    components: {
        SiteDocumentForm,
        BoxWithTitle,
        NoPermissionAlert,
    },
    mixins: [
        FormPageMixin,
    ],
    computed: {
        ...mapGetters([
            'site',
            'siteDocument',
            'hasPermission',
        ]),
        defaultData() {
            return this.siteDocument;
        },
    },
    methods: {
        ...mapActions([
            'getSiteDocument',
            'resetSiteDocument',
        ]),
        onClickConfirmRemove() {
            this.$root.$emit('showModal', {
                title: this.$t('sites.document.remove'),
                component: Vue.component('ConfirmForm', ConfirmForm),
                payload: { msg: this.$t('sites.document.confirmRemove') },
                onConfirm: () => this.removeRequest(),
                isForm: false,
            });
        },
        async onClickUpdate() {
            let payload = this.$utils.getObjectsDifference(this.updatedData, this.defaultData);
            payload = this.$utils.removeEmptyNullOrUndefined(payload);

            const request = new FormData();
            Object.keys(payload).forEach(key => {
                if (typeof payload[key] === 'object') {
                    request.append(key, JSON.stringify(payload[key]));
                } else {
                    request.append(key, payload[key]);
                }
            });

            const { id: documentId, code } = this.updatedData;
            const { id: siteId } = this.site;
            await this.$rq.updateSiteDocument(siteId, documentId, request);
            this.cancelModifications();
            this.$toasted.global.toast_success({
                message: this.$t('msg.documentUpdated', { data: code }),
            });
        },
        async removeRequest() {
            const { id, code } = this.defaultData;

            await this.$rq.deleteSiteDocument(this.site.id, id);

            this.resetSiteDocument();
            this.$toasted.global.toast_success({
                message: this.$t('msg.documentRemoved', { data: code }),
            });

            await this.$router.push({ name: 'siteDocuments' });
        },
    },
};
</script>
